(function(Sliders, $, undefined) {

  const handleSliderClick = function(self, direction) {
    const $sliderContainer = $(self).closest('[data-parallax-slider]');
    const $activeSlide = $sliderContainer.find('.parallax-section--active');
    const slideCount = $sliderContainer.find('.parallax-section').length;
    const currentSlideIndex = parseInt($activeSlide.attr('data-slide-index'));
    let slideToShowIndex;

    if (direction === 'prev') {
      slideToShowIndex = currentSlideIndex - 1;
    } else {
      slideToShowIndex = currentSlideIndex + 1;
    }

    if (slideToShowIndex > slideCount) {
      slideToShowIndex = 1;
    } else if (slideToShowIndex === 0) {
      slideToShowIndex = slideCount;
    }

    $activeSlide.removeClass('parallax-section--active');
    $sliderContainer.find('[data-slide-index="' + slideToShowIndex + '"]').addClass('parallax-section--active');

  }

  const initSliders = function() {
    // $('.pr-slider-desktop').slick({
    //   dots: true,
    //   customPaging: function(slider, i) {
    //     var thumb = $(slider.$slides[i]).data('thumb');
    //     return '<a><img class="pr-slider__slide-img" src="'+thumb+'"></a>';
    //   },
    //   appendDots: $('.pr-dots'),
    //   fade: true
    // })

    $('.pr-slider-mobile').slick({
      dots: true,
    })

    $('.pr-slider-mobile').slick('slickGoTo', 2);

    $('.social-slider').slick({
      mobileFirst: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            arrows: true,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            centerPadding: '125px'
          }
        },
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 4,
            centerPadding: '125px'
          }
        },
      ]
    });
  }
  
  const bindUIActions = function() {

    $('[data-parallax-slide-prev]').on('click', function() {
      handleSliderClick(this, 'prev');
    });

    $('[data-parallax-slide-next]').on('click', function() {
      handleSliderClick(this, 'next');
    });
  }
  // Public
  Sliders.init = function() {
    bindUIActions();
    initSliders();
  };

}(window.Sliders = window.Sliders || {}, jQuery));